module.exports = global["$"] = require("-!/data/fp-commerce/shared-live/tmp/shop/node_modules/expose-loader/index.js?jQuery!./jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ../~/expose-loader?$!../~/expose-loader?jQuery!../~/jquery/dist/jquery.js-exposed
 ** module id = 381
 ** module chunks = 10
 **/